import React from 'react';

import { Skeleton } from '@crm-framework/skeleton';
import { Spacing } from '@crm-framework/spacing';
import { colors } from '@crm-framework/theme';
import { Loader } from '@crm-framework/loader';

import {
  NotificationsHeaderWrapper,
  NotificationsHeaderContent,
} from '../../styles';

export const NotificationSkeleton: React.FC = () => (
  <>
    <NotificationsHeaderWrapper>
      <NotificationsHeaderContent>
        <Spacing mr={10}>
          <Skeleton width={150} height={36} />
        </Spacing>
        <Skeleton variant="circle" width={25} height={25} />
      </NotificationsHeaderContent>
      <Skeleton variant="circle" width={25} height={25} />
    </NotificationsHeaderWrapper>
    <Spacing mb={100}>
      <Skeleton height={40} />
    </Spacing>
    <Loader color={colors.SKELETON} />
  </>
);
